import { InnerBox } from "@/components/elements/InnerBox";
import { Stack, styled, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { blue } from "@/theme/colors";
import { CaseBaseInfoForm } from "@/features/case/components/CaseBasicInfo/CaseBaseInfoForm";
import React, { useState } from "react";
import { CASE_BASIC_INFO_TAB, CASE_BASIC_INFO_TAB_LABEL } from "@/features/case/constants/caseBasicInfoTab";
import { CaseJobInfo } from "@/features/case/components/CaseBasicInfo/CaseJobInfo";
import { CaseRequestInfo } from "@/features/case/components/CaseBasicInfo/CaseRequestInfo";
import { FCC } from "@/types/common";
import { TGetJobDto } from "@/api/services/main/job/dtos/get-job.dto";

type CaseBasicInfoProps = {
  jobInfo: TGetJobDto;
};
export const CaseBasicInfo: FCC<CaseBasicInfoProps> = ({ jobInfo }) => {
  const [actionTab, setActionTab] = useState(CASE_BASIC_INFO_TAB.BASIC_FORM);

  const handleChange = (event: React.MouseEvent<HTMLElement>, newValue: number) => {
    if (!newValue) {
      setActionTab(CASE_BASIC_INFO_TAB.BASIC_FORM);
    }
    setActionTab(newValue);
  };

  const getTitle = () => {
    return CASE_BASIC_INFO_TAB_LABEL[actionTab];
  };

  return (
    <InnerBox mt={4} showDivider={false}>
      <Stack direction="row" justifyContent="space-between" mb={4}>
        <Typography variant="head20Bold">{getTitle()}</Typography>
        <ToggleButtonGroupStyle color="secondary" value={actionTab} onChange={handleChange} exclusive size="small">
          <ToggleButton value={CASE_BASIC_INFO_TAB.BASIC_FORM}>
            <Typography variant="body14">{CASE_BASIC_INFO_TAB_LABEL[CASE_BASIC_INFO_TAB.BASIC_FORM]}</Typography>
          </ToggleButton>
          <ToggleButton value={CASE_BASIC_INFO_TAB.JOB_INFO}>
            <Typography variant="body14">{CASE_BASIC_INFO_TAB_LABEL[CASE_BASIC_INFO_TAB.JOB_INFO]}</Typography>
          </ToggleButton>
          <ToggleButton value={CASE_BASIC_INFO_TAB.REQUEST}>
            <Typography variant="body14">{CASE_BASIC_INFO_TAB_LABEL[CASE_BASIC_INFO_TAB.REQUEST]}</Typography>
          </ToggleButton>
        </ToggleButtonGroupStyle>
      </Stack>
      {actionTab === CASE_BASIC_INFO_TAB.BASIC_FORM && <CaseBaseInfoForm />}
      {actionTab === CASE_BASIC_INFO_TAB.JOB_INFO && <CaseJobInfo jobInfo={jobInfo} />}
      {actionTab === CASE_BASIC_INFO_TAB.REQUEST && <CaseRequestInfo jobInfo={jobInfo} />}
    </InnerBox>
  );
};

const ToggleButtonGroupStyle = styled(ToggleButtonGroup)`
  border-radius: 16px;
  height: 32px;

  button {
    border: 2px solid ${blue[80]};
    height: 32px;
    width: 88px;
    color: ${blue[80]};
  }

  button.Mui-selected {
    background-color: ${blue[80]};
    color: white;
  }
`;
